import {inject, Injectable, signal} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {ApiService} from "../../../services/api.service";
import {firstValueFrom} from "rxjs";
import {AiConfiguration, RULES_SNIPPET} from "../../../shared/interfaces/ai-configuration";

@Injectable({
  providedIn: 'root'
})
export class AiService {
  public isGenerating = signal<boolean>(false);
  private apiService = inject(ApiService);

  async generateSolution(inputText: string): Promise<string> {
    this.isGenerating.set(true);
    try {
      const configs: AiConfiguration[] = await firstValueFrom(this.apiService.getAiConfigurations());
      const activeConfig: AiConfiguration = configs.find(c => c.is_active) ?? configs[0] ?? null;
      const systemPromptWithRules = this.appendPromptFormatingRules(activeConfig.system_prompt)

      const payload: Record<string, unknown> = {
        content: inputText.replace(/<[^>]+>/g, ''),
        systemPrompt: systemPromptWithRules,
        model: activeConfig?.model_name,
        temperature: activeConfig?.temperature ?? 0.7,
        maxTokens: activeConfig?.max_tokens ?? 1500
      };


      const response = await fetch(environment.editorAiPluginEndpoint, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'X-Api-Key': 'Qundis2024'},
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const details = await response.text().catch(() => '');
        throw new Error(`AI-Service Fehler ${response.status} ${details}`);
      }

      const data: { response?: string } = await response.json();
      if (!data?.response) {
        throw new Error('Leere KI-Antwort');
      }
      return `<h3>Lösungsvorschlag</h3>\n${data.response}`;
    } finally {
      this.isGenerating.set(false);
    }
  }

  appendPromptFormatingRules(systemPrompt: string): string {
    const base = (systemPrompt || '').trim();
    if (!base) return RULES_SNIPPET;
    if (this.containsRules(base)) return base;
    return `${base}\n\n${RULES_SNIPPET}`;
  }

  private containsRules(prompt: string): boolean {
    if (!prompt) return false;
    return prompt.includes('Ausgabeformat:') && prompt.includes('Erlaubte Tags:');
  }
}
